/**
 * @generated SignedSource<<7678f600bf7ddd53280899dd725f8432>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Stripe__CheckoutSessionPayload",
    "kind": "LinkedField",
    "name": "stripeCheckoutSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StripeCheckoutSessionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StripeCheckoutSessionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd00c6d3ad77e5de9fafc7bf537d5fb7",
    "id": null,
    "metadata": {},
    "name": "StripeCheckoutSessionMutation",
    "operationKind": "mutation",
    "text": "mutation StripeCheckoutSessionMutation(\n  $input: Stripe__CheckoutSessionInput!\n) {\n  stripeCheckoutSession(input: $input) {\n    sessionId\n    error\n  }\n}\n"
  }
};
})();

node.hash = "ee4745004d32488bf108d6c59634bd4f";

module.exports = node;
